import { Timezones } from '../util/timezones.js';
export class API {

  currentNode = "https://api.saopaulo.basquetpass.tv";
  availableNodes = [{
    id: 1,
    node: 'https://api.saopaulo.basquetpass.tv',
    continent: 'SA',
    write: true
  }];

  apiNodeUrl = '';

  constructor(brandId, _this) {
    this.self = _this;
    this.brandId = brandId;
  }


  getNode(write = false) {

    if (location.href.includes('127.0.0.1')) {
      return 'http://127.0.0.1:81';
    }

    // if (location.href.includes('192.168')) {
    //   return 'http://192.168.100.128:81';
    // }

    let user = this.self.user.current_user;

    //Si nos llega host de developer, lo usamos
    if (user && user.dev_host) {
      this.currentNode = user.dev_host;
      return this.currentNode;
    }

    if (this.currentNode != -1 && !write) return this.currentNode; //Si lo teníamos guardado lo devolvemos	

    var nodes = Array();

    //Si no tenemos la región actual, elegimos uno aleatorio
    if (!user.isocode && !write) {
      this.availableNodes.forEach(node => {
        if (node.write == write) {
          nodes.push(node);
        }
      });

      if (nodes.length > 0) {
        this.currentNode = nodes[Math.floor(Math.random() * nodes.length)].node;
        return this.currentNode;
      }
    }

    //Recorremos los nodos disponibles en nuestra región para elegir de entre ellos uno aleatorio

    this.availableNodes.forEach(node => {
      if (node.continent == user.isocode.continent && node.write == write) {
        nodes.push(node);
      }
    });

    if (nodes.length > 0) {
      this.currentNode = nodes[Math.floor(Math.random() * nodes.length)].node;
      return this.currentNode;
    }


    //Devolvemos uno aleatorio del todo
    this.currentNode = this.availableNodes[Math.floor(Math.random() * this.availableNodes.length)].node;
    return this.currentNode;

  }


  async call(func, data = null, options = { retry: 5, write: false }) {
    const { retry, write } = options;

    let user = this.self.user.current_user;

    const n = 100000 + Math.floor(Math.random() * 899999);
    const x = sha512(n + window.navigator.userAgent);

    if (data == null) {
      data = Object();
    }

    if (typeof (data) == "undefined" || data == null) {
      data = new Object();
    };

    // Añadimos los datos del usuario
    data.user_session = user && user.session_hash ? user.session_hash : '';
    data.user_id = user && user.id ? user.id : 0;

    // Añadimos Timezone
    // Intentamos obtener la zona horaria del navegador
    data.tz = 0;
    data.gmt = 0;
    try {
      let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      data.tz = Timezones.getTimezoneByName(timezone);

      // Sacamos el GMT de la zona horaria
      let date = new Date();
      let offset = date.getTimezoneOffset();
      data.gmt = -offset / 60; // Convertimos a horas
      
    } catch (error) { }

    // Analítica
    data.e = this.self.actions.getActions(); // Acciones pendientes de enviar    
    data.playing = JSON.stringify(this.self.actions.getPlaying()); // Reproducciones

    data.f = func;
    data.x = n + x;
    data.b = this.brandId;

    // Hacemos la llamada
    try {
      data = await this._call('/?call', data, { retry, write });
    } catch (error) {
      throw error;
    }

    if (data == '') {
      throw new Error('Empty response');
    }

    // Limpiamos las acciones pendientes
    this.self.actions.clear();

    data = data.split('\n').slice(-1)[0]; // Por si hay error o depuracion

    try {
      data = JSON.parse(data);
    } catch (error) {
      console.error("[API] Error parsing response: ", error);
      return;
    }

    //Si tenemos ms del profiler lo movemos antes
    if (data.result && data.r) {
      data.result.r = data.r;
    }

    if (data.error) {
      return data;
    }

    return data.result;
  }


  /**
   * Realiza la llamada fetch
   *
   * @param {*} url 
   * @param {*} [data=null] 
   * @param {boolean} [options={ retry: 5, write: false }] 
   * @return 
   * @memberof API
   */
  async _call(url, data = null, options = { retry: 2, write: false }) {
    const { retry, write } = options;
    let attempts = 0;

    while (attempts < retry) {
      try {
        const response = await fetch(this.getNode(write) + url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(data),
          credentials: 'include',
          cache: 'no-cache',
        });

        if (!response.ok) {
          throw new Error('Error en la petición');
        }

        return await response.text();
      } catch (error) {
        attempts++;
        if (attempts >= retry) {
          console.error('[API] Error: ', error.message);
          throw error;
        } else {
          console.warn(`[API] (${attempts} / 5)`, error.message);
          await this._wait(5000);  // Espera 5 segundos antes de reintentar
        }
      }
    }
  }


  /**
   * Espera un tiempo determinado
   *
   * @param {*} ms 
   * @return 
   * @memberof API
   */
  _wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  /**
   * Hace una llamada a la API sin parámetros, normalmente para actualizar métricas
   *
   */
  emptyCall() {
    this.call('blank', null, { retry: 0 });
  }

  /**
 * Abre una URL de descarga de algo desde la API
 *
 * @param {*} url 
 * @param {*} [params=null] 
 */
  async download(func, params = null) {

    let user = this.self.user.current_user;
    var node = await this.self.api.getNode();

    if (!params) {
      params = new Object();
    }

    if (!user.id) {
      user.id = Cookies.get('USERSESSID');
      if (!user.id || user.id == 'undefined') {
        user.id = 0;
      }
    }

    const n = 100000 + Math.floor(Math.random() * 899999);
    const x = sha512(n + window.navigator.userAgent);

    params.user_session = user && user.session_hash ? user.session_hash : '';
    params.user_id = user && user.id ? user.id : 0;
    params.x = n + x;
    params.f = func;

    // Abrimos en una nueva ventana todo por GET
    window.open(node + '/?call&' + $.param(params), '_blank');

  }


}
